import React from 'react';

export default function Rodape() {
    return (
        <div>
            <div id="back-top">
                <a href="#header"><i className="fa fa-chevron-up"></i></a>
            </div>
            <div id="footer-widgets">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-8 col-sm-8 col-md-6 col-lg-6">
                            <h3 className="titulo-Rodape">Mapa do Site</h3>
                            <ul className="list-unstyled two_cols">
                                <li><a href="#convite">Convite</a></li>
                                <li><a href="#sobre">Sobre</a></li>
                                <li><a href="#depoimentos">Depoimentos</a></li>
                                <li><a href="#inscricao">Inscrição</a></li>
                                <li><a href="#contato">Contato</a></li>
                                <li><a href="https://www.evangelhoeamor.com.br/" target="_blank" rel="noopener noreferrer">CEEA</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="row margin-top-20">
                        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                            <h6 className="no-margin-top texto-Rodape">&copy; Centro Espírita Evangelho e Amor - Todos os direitos reservados.</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}